import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Resources.css';
import Tabbar from '../../Components/Tabbar/Tabbar';
import { getAll, add, del, edit, clearSuccess, clearSecondarySuccess, clearTertiarySuccess } from '../../Store/Actions/RestActions';
import PageFilter from '../../Components/Pages/PageFilter';
import ResourcesPageComponent from '../../Components/Pages/ResourcesPageComponent';
import ResourceTypesModal from '../../Components/Modals/ResourcesTypesModal';
import ResourceDetailTypesModal from '../../Components/Modals/ResourceDetailTypesModal';
import SuccessModal from '../../Components/successModal';
import SecondarySuccessModal from '../../Components/secondarySuccessModal';
import TertiarySuccessModal from '../../Components/tertiarySuccessModal';

class ResourcesPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activePage: 1,
		};
		this.handlePageChange = this.handlePageChange.bind(this);


	}

	handlePageChange(pageNumber) {
		this.setState({ activePage: pageNumber });
	}



	componentDidMount() {
		this.props.resourceTypeFetch();
		this.props.assetsFetch();
		this.props.assetDetailTypeFetch();
	}

	render() {
		return (
			<div>
				<div className="container">
					<Tabbar setActiveTab="resources" />
					<div className="contentBox tabbed-content-box no-padding">
						<PageFilter {...this.props}>
							<ResourcesPageComponent />
						</PageFilter>
						<div className="gear-container">
							<ResourceTypesModal items={this.props.resourceTypes} handleSubmit={this.props.addResourceType} handleEdit={this.props.editResourceType} {...this.props} handleDeleteClick={this.props.deleteResourceType} />
							<ResourceDetailTypesModal items={this.props.resourceDetailTypes} handleSubmit={this.props.addResourceDetailType} handleEdit={this.props.editResourceDetailType} handleDeleteClick={this.props.deleteResourceDetailType}{...this.props} />
						</div>

					</div>
				</div>
				<SuccessModal success={this.props.success} successMsg="Resource action completed successfully." onClose={this.props.clearSuccess}></SuccessModal>
				<SecondarySuccessModal success={this.props.resourceTypesSuccess} successMsg="Resource Type action completed successfully" onClose={this.props.clearSecondarySuccess}></SecondarySuccessModal>
				<TertiarySuccessModal success={this.props.resourceDetailTypesSuccess} successMsg="Resource Detail Type action completed successfully" onClose={this.props.clearTertiarySuccess}></TertiarySuccessModal>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		schedule: state.schedulePage,
		roomTypes: state.roomTypes.data,
		resources: state.assets.data,
		resourceTypes: state.assetTypes.data,
		resourceDetailTypes: state.assetDetailTypes.data,
		filterData: state.assets.data,
		success: state.assets.success,
		resourceTypesSuccess: state.assetTypes.success,
		resourceDetailTypesSuccess: state.assetDetailTypes.success
	};

};

const mapDispatchtoProps = (dispatch) => {
	return {
		addClick: data => dispatch(add('resources', data)),
		addResourceDetailType: data => dispatch(add('assetdetailtypes', data)),
		editResourceDetailType: data => dispatch(edit('assetdetailtypes', data, data.id)),
		deleteResourceDetailType: id => dispatch(del('assetdetailtypes', {}, id)),
		addResourceType: data => dispatch(add('assettypes', data)),
		editResourceType: data => dispatch(edit('assettypes', data, data.id)),
		deleteResourceType: id => dispatch(del('assettypes', {}, id)),
		resourceTypeFetch: () => dispatch(getAll('assettypes', {})),
		assetsFetch: () => dispatch(getAll('assets', {})),
		assetDetailTypeFetch: () => dispatch(getAll('assetdetailtypes', {})),
		deleteClick: (id) => dispatch(del('assets', {}, id)),
		clearSuccess: () => dispatch(clearSuccess('assets')),
		clearSecondarySuccess: () => dispatch(clearSecondarySuccess('assetTypes')),
		clearTertiarySuccess: () => dispatch(clearTertiarySuccess('assetDetailTypes'))
	};
};
export default connect(mapStateToProps, mapDispatchtoProps)(ResourcesPage);



// WEBPACK FOOTER //
// ./src/Pages/Resources/Resources.js